// Texts of the modern design live in the `front` translation group under `modern.*`
// (docs/modern-design-translations.sql). The English fallback keeps the UI readable
// on installations where the rows were not imported yet.
export default {
  methods: {
    tm (key, fallback, params = {}) {
      const full = `modern.${key}`
      if (this.$te(full) && this.$t(full)) {
        return this.$t(full, params)
      }

      return fallback.replace(/\{(\w+)\}/g, (match, name) => (name in params ? params[name] : match))
    },
  },
}
